function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M17.3337 9.16667C17.8859 9.16667 18.3337 8.71895 18.3337 8.16667V3.5C18.3337 2.94771 17.8859 2.5 17.3337 2.5H13.5003C12.948 2.5 12.5003 2.94772 12.5003 3.5V5.2H7.50033V3.5C7.50033 2.94772 7.05261 2.5 6.50033 2.5H2.66699C2.11471 2.5 1.66699 2.94772 1.66699 3.5V8.16667C1.66699 8.71895 2.11471 9.16667 2.66699 9.16667H6.50032C7.05261 9.16667 7.50033 8.71895 7.50033 8.16667V6.5H9.50049V14.8H12.5003V16.5C12.5003 17.0523 12.948 17.5 13.5003 17.5H17.3337C17.8859 17.5 18.3337 17.0523 18.3337 16.5V11.8333C18.3337 11.281 17.8859 10.8333 17.3337 10.8333H13.5003C12.948 10.8333 12.5003 11.281 12.5003 11.8333V13.3333H10.8005V6.5H12.5003V8.16667C12.5003 8.71895 12.948 9.16667 13.5003 9.16667H17.3337Z",
  fill: "#4C86B7"
});

function SvgAutoAttendant(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAutoAttendant);
export default __webpack_public_path__ + "static/media/autoAttendant.5bcbc4d1.svg";
export { ForwardRef as ReactComponent };